function renderCustomImageBannerElement(
    customBannerImageContainer,
    customBannerImageLink = null,
    customBannerImage = '',
    openLinkInNewTab = false,
    customBannerImageText = '',
    customBannerImageHeadingTextAlignment = 'center'
) {
    if (customBannerImageLink !== null) {
        if (openLinkInNewTab) {
            customBannerImageContainer.innerHTML =
                '<a href="' + customBannerImageLink + '" target="_blank">' +
                    '<div class="custom-banner-image">' +
                        '<img src="' + customBannerImage + '" alt="banner-image">' +
                        '<div class="custom-banner-image-heading-text ' + customBannerImageHeadingTextAlignment + '">' +  customBannerImageText + '</div>' + 
                    '</div>' +
                '</a>';
        } else {
            customBannerImageContainer.innerHTML =
                '<a href="' + customBannerImageLink + '">' +
                    '<div class="custom-banner-image">' +
                        '<img src="' + customBannerImage + '" alt="banner-image">' +
                        '<div class="custom-banner-image-heading-text ' + customBannerImageHeadingTextAlignment + '">' +  customBannerImageText + '</div>' + 
                    '</div>' +
                '</a>';
        }
    } else {
        customBannerImageContainer.innerHTML =
            '<div class="custom-banner-image">' +
                '<img src="' + customBannerImage + '" alt="banner-image">' +
                '<div class="custom-banner-image-heading-text ' + customBannerImageHeadingTextAlignment + '">' +  customBannerImageText + '</div>' + 
            '</div>';
    }
}